<template>
  <div class="tag-print-record">
    
    <div class="search-box">
      <div class="row1Item">
        <div class="lable-width">打印时间</div>
        <el-date-picker class="width-fixed picker" value-format="yyyy-MM-dd HH:mm:ss" v-model="printDate" type="datetimerange" range-separator="~" :start-placeholder="`开始时间`" :end-placeholder="`结束时间`" :default-time="['00:00:00','23:59:59']">
        </el-date-picker>
      </div>
      <div class="row1Item">
        <div class="lable-width">灭菌时间</div>
        <el-date-picker class="width-fixed picker" value-format="yyyy-MM-dd HH:mm:ss" v-model="sterilizationDate" :default-time="['00:00:00','23:59:59']" type="datetimerange" range-separator="~" :start-placeholder="`开始时间`" :end-placeholder="`结束时间`">
        </el-date-picker>
      </div>
      <div class="row1Item">
        <div class="lable-width">标签名称</div>
        <el-select
          class="width-fixed" 
          :placeholder="`请选择`" 
          v-model="queryForm.tag_id" 
          clearable
          filterable
          remote
          :remote-method="getTagList"
          @focus="getTagList()"
          >
          <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">器械包名称</div>
        <el-select class="width-fixed" v-model="queryForm.instrumentset_id" filterable clearable remote :placeholder="`请选择`" :remote-method="searchInstruments" @focus="searchInstruments('')" value-key="name">
          <el-option v-for="(item) in instrumentsetList" :key="item.pk_id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">包装材料名称</div>
        <el-select class="width-fixed" :placeholder="`请选择`" v-model="queryForm.pack_option" clearable>
          <el-option v-for="item in packList" :key="item.id" :label="item.name" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">灭菌器名称</div>
        <el-select class="width-fixed" v-model="queryForm.equipment_id" :placeholder="`请选择`" clearable>
          <el-option v-for="item in equipmentOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">组配人</div>
        <el-select class="width-fixed" filterable clearable remote :remote-method="getUserList" @focus="getUserList('')" :placeholder="`请选择`" v-model="queryForm.pack_uid">
          <el-option v-for="item in registerUserList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">包装人</div>
        <el-select class="width-fixed" filterable clearable remote :remote-method="getUserList" @focus="getUserList('')" v-model="queryForm.package_uid" :placeholder="`请选择`">
          <el-option v-for="item in registerUserList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">审核人</div>
        <el-select class="width-fixed" filterable clearable remote :remote-method="getUserList" @focus="getUserList('')" v-model="queryForm.check_uid" :placeholder="`请选择`">
          <el-option v-for="item in registerUserList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">打印人</div>
        <el-select class="width-fixed" filterable remote :remote-method="getUserList" @focus="getUserList('')" v-model="queryForm.print_uid" clearable :placeholder="`请选择`">
          <el-option v-for="item in registerUserList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">灭菌方式</div>
        <el-select
          class="width-fixed"
          v-model="queryForm.handle_option"
          :placeholder="`请选择`"
          clearable>
          <el-option
            v-for="item in sterilizeMethods" 
            :key="item.id" 
            :label="item.name" 
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">打印渠道</div>
        <el-select
        class="width-fixed"
          v-model="queryForm.platform"
          :placeholder="`请选择`"
          clearable>
          <el-option :label="`移动端打印`" :value="2"></el-option>
          <el-option :label="`PC端打印`" :value="1"></el-option>
        </el-select>
      </div>
      <div class="row1Item">
        <div class="lable-width">灭菌人</div>
        <el-select class="width-fixed" filterable clearable remote :remote-method="getUserList" @focus="getUserList('')" :placeholder="`请选择`" v-model="queryForm.sterilization_uid">
          <el-option v-for="item in registerUserList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="row1Item" style="width: 424px;padding-top:10px;">
        <el-button type="primary" size="small" @click="getList">查询</el-button>
        <el-button type="primary" size="small" @click="exportList">导出</el-button>
      </div>
    </div>
    <el-table :data="list" border v-loading="loading" @sort-change="sortChange">
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column v-for="(item) in tableHeaders" :key="item.id" :type="item.type" :label="item.label" :prop="item.prop" :sortable="!!item.sortKey ? 'custom': false" :sort-by="item.sortKey" :width="item.width">
        <template slot-scope="scope">
          <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
          <template v-else-if="item.prop === 'handle'">
            <el-button type="text" @click.prevent="checkFun(scope.row)">查看</el-button>
            <el-button type="text" @click.prevent="reprintFun(scope.row)">补打</el-button>
            <el-button type="text" @click.prevent="reprintDetail(scope.row)">补打明细</el-button>
          </template>
          <span v-else>{{scope.row[item.prop]}}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :queryParams="queryForm" :getList="getList" />
    <!-- 补打明细的弹框 -->
    <el-dialog :title="`补打明细`" :visible.sync="show" width="50%">
      <div class="row1">
        <div class="row1Item">
          <div>打印时间：</div>
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00','23:59:59']" v-model="detailPrintDate" type="datetimerange" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`">
          </el-date-picker>
        </div>
        <div class="row1Item">
          <div>打印人：</div>
          <el-select filterable clearable remote :remote-method="getUserList" @focus="getUserList('')" v-model="detailPrintUid" :placeholder="`请选择`">
            <el-option v-for="item in registerUserList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="row1Item">
          <el-button class="ml10" type="primary" size="small" @click="getPrintLogList">查询</el-button>
        </div>
      </div>
      <el-table :data="detailList" border v-loading="loading">
        <el-table-column v-for="(item) in detailTableHeaders" :key="item.id" :type="item.type" :label="item.label" :prop="item.prop" :sortable="!!item.sortKey ? 'custom': false" :sort-by="item.sortKey" :width="item.width">
          <template slot-scope="scope">
            <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
            <span v-else>{{scope.row[item.prop]}}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="detailQueryForm" :getList="getPrintLogList" />
    </el-dialog>
    
    <!-- 预览标签iframe -->
    <frame ref="frame" />

    <!-- 补打张数 -->
    <count
      ref="count"
      @confirm="getCount"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import tagMixin from '@/mixins/tag'
import KeysMixin from '../mixins/keys'
import Pagination from "@/components/common/Pagination.vue";
import Frame from '@/components/common/Frame'
import Count from '../components/count.vue'
import {
  instrumentPackageOptions,
  getEquipment,
  userOptions,
  printList,
  printLog,
  getTag,
  tagPrintDetail,
  tagTemplatePrint ,
  tagPrintExport
} from "@/api.js";
import { pageSize } from "@/utils/Config.js";
export default {
  components: {
    Pagination,
    Frame,
    Count
  },
  mixins: [ tagMixin, KeysMixin ],
  computed: {
    ...mapGetters([ 'user' ])
  },
  data() {
    return {
      loading: true,
      show: false,
      printDate: "", //打印时间
      sterilizationDate: "", //灭菌时间
      tagList: [], //标签列表
      instrumentsetList: [], //器械包列表
      packList: [], //包装材料
      equipmentOptions: [], //灭菌器列表
      registerUserList: [], //组配人数组
      queryForm: {
        instrumentset_id: "", //选择的器械包
        pack_option: "", //选择的包装材料
        equipment_id: "", //选择的灭菌器
        pack_uid: "", //选择的组配人
        package_uid: "", //选择的包装人
        check_uid: "", //选择的审核人
        print_uid: "", //选择的打印人
        tag_id: "", //选择的标签
        pageIndex: 1,
        pageSize,
        _total: 0,
      },
      tableHeaders: [],
      list: [],
      detailPrintDate: [], //补打明细弹框里的日期时间
      detailList: [], //补打明细中的列表
      detailTableHeaders: [],
      detailQueryForm: {
        pageIndex: 1,
        pageSize,
        _total: 0,
      },
      detailPrintUid: "",
      handleItem: null,
      sterilizeMethods: []
    };
  },
  mounted() {
    this.getList();
    this.getDicts();
    this.getEquipments();
    this.getUserList();
  },
  methods: {
    // 查看
    async checkFun(item) {
      const {
        id,
        tag_id
      } = item
      const data = await this.getPrintHtmlString(id, tag_id)
      if (!data) return
      const { s, w, h } = data
      
      this.$refs.frame.open(s, `${w}x${h}`)
    },

    getPrintDetail(id) {
      // 获取打印记录详情
      const url = tagPrintDetail.replace('{id}', id)
      return this.$request('get', url)
    },

    getPrintHtmlString(id, tag_id = 0, count = 1) {
      return new Promise(r => {
        Promise.all([this.getPrintDetail(id)])
        .then(res => {
          if (res) {
            const detail = res[0]
            // const template = res[1]
            // const {
            //   size
            // } = template
            const {
              content,
              tag_size: size
            } = detail

            if (!size || !content) {
              console.error('获取模板和详情出错')
              r(null)
              return
            }
            const sizeArray = size.toLowerCase().split('x')
            const w = sizeArray[0] ? Number(sizeArray[0]) : 0
            const h = sizeArray[1] ? Number(sizeArray[1]) : 0
            let contentData = []
            try {
              contentData = JSON.parse(content)
              contentData.forEach(item=>{
                if(item.type == 'serial_number'){
                  item.text = res[0].serial_number
                }
              })
            } catch (error) {
              console.error('解析详情出错')
              r(null)
              return
            }

            const data = {
              content: contentData,
              w,
              h
            }
            const countData = new Array(count).fill({})
            data.content = this._labelIdenCode(data.content)
            const htmlString = this._generateTagHtml(data, countData)

            r({
              s: htmlString,
              w,
              h,
              printData: detail,
              // templateData: template
            })
          }
        })
      })
    },

    // 补打
    async reprintFun(item) {
      const {
        is_delete
      } = item

      if (is_delete == 1) {
        this.$message.error(`该标签模版已被禁用，无法打印！`)

        return
      }

      const {
        auth_type
      } = this.user
      if (auth_type === 2) {
        const confirm = await this.$utils.printWarningConfirm(`将消耗打印可用标签数量，是否继续操作？`)
        
        if (!confirm) return 
      }

      const {
        count
      } = this.$refs

      this.handleItem = item
      count && count.open()
    },

    async getCount(data) {
      if (!this.handleItem || !data) return

      const {
        id,
        tag_id
      } = this.handleItem
      const {
        count,
        printUser
      } = data
      const detail = await this.getPrintHtmlString(id, tag_id, count)
      if (!detail) return
      const {
        s,
        printData
      } = detail

      let isSuccess = await this.postRePrintData(printData, count, printUser)
      if(isSuccess === null) return
      let html = ''
      try {
        const detailPram = {
          size: detail.printData.tag_size,
          content: detail.printData.content
        }
        const printData = this._parseSmartTagConfigByDetail(detailPram)
        const { tag } = printData
        let { content } = tag
        content = await this._setLogoByData(content, detail.printData.tenant_id)
        // 如果有流水号，需要添加流水号
        content = this._setSerialNumber(content,isSuccess.serial_number)
        // 如果有标签识别码
        content = this._labelIdenCode(content)
        printData.tag.content = content
        const ins_code = new Array(Number(count)).fill({})
        html = this._generatePrintHtml(printData, {ins_code})
      } catch (error) {
        console.error('解析详情出错')
        return
      }
      this.$utils.print(html, 'smartTag')
      this.getList()
    },

    postRePrintData(printData, count, printUser) {
      // 提交补打数据
      const apiKeys = ['content', 'id']
      const printKeys = {}
      for (const key in printData) {
        apiKeys.forEach(i => {
          if (Object.hasOwnProperty.call(printData, key) && i === key) {
            printKeys[i] = printData[key]
          }
        })
      }
      printKeys.num = count
      printKeys.print_uid = printUser
      printKeys.platform = 1 // 打印渠道
      return this.$request('post', tagTemplatePrint, printKeys)
    },

    // 补打明细
    reprintDetail(data) {
      this.show = true;
      this.printItem = data; // 这里不能使用传参的形式，因为点击下一页和查询时是没有传参的
      this.getPrintLogList();
    },

    //获取补打明细
    getPrintLogList() {
      let data = this.printItem;
      let query = {};
      if (this.detailPrintDate) {
        query.start = this.detailPrintDate[0];
        query.end = this.detailPrintDate[1];
      }
      if (this.detailPrintUid) {
        query.print_uid = this.detailPrintUid;
      }
      query.platform = 1
      const url = printLog.replace("{id}", data.id);
      this.$request("get", url, query).then((res) => {
        if (res) {
          const prev = [
            {
              width: 60,
              label: '#',
              prop: "",
              type: "index",
              checked: true,
            },
          ];

          this.detailTableHeaders =
            this.detailTableHeaders.length > 0
              ? this.detailTableHeaders
              : this.$utils.generateColumns(res.columns, prev);
          this.detailList = res.data;
          this.detailQueryForm._total = res.total;
          this.loading = false;
        }
      });
    },

    getQuery() {
      // 整理参数
      const newQueryForm = {};
      for (const key in this.queryForm) { // 去掉请求里的字段为空的值
        if (this.queryForm[key] !== "" && key != 'pageSize' && key != 'pageIndex') {
          newQueryForm[key] = this.queryForm[key];
        }
      }
      if (this.printDate) { // 如果选择了打印日期
        newQueryForm.print_start = this.printDate[0];
        newQueryForm.print_end = this.printDate[1];
      }
      if (this.sterilizationDate) { // 如果选择了灭菌日期
        newQueryForm.sterilization_start = this.sterilizationDate[0];
        newQueryForm.sterilization_end = this.sterilizationDate[1];
      }
      newQueryForm.per_page = this.queryForm.pageSize
      newQueryForm.page = this.queryForm.pageIndex
      newQueryForm.order = this.queryForm.order
      newQueryForm.orderBy = this.queryForm.orderBy

      return newQueryForm
    },

    // 获取列表数据
    getList() {
      const newQueryForm = this.getQuery()
      this.$request("get", printList, newQueryForm).then((res) => {
        if (res) {
          this.tableHeaders =
            this.tableHeaders.length > 0
              ? this.tableHeaders
              : this.$utils.generateColumns(res.columns);
          this.list = res.data;
          this.queryForm._total = res.total;
          this.loading = false;
        }
      });
    },

    // 导出列表
    exportList() {
      const querys = this.getQuery()
      delete querys.per_page
      delete querys.page
      
      this.$utils.exportFile(tagPrintExport, querys)
    },

    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryForm.order = orderString
      this.queryForm.orderBy = orderBy
      this.getList()
    },

    //获取器械包
    searchInstruments(query) {
      const params = {
        search: query || "",
      };
      const url = instrumentPackageOptions;
      this.$request("post", url, params).then((res) => {
        this.instrumentsetList = res;
      });
    },

    // 获取字典
    getDicts() {
      this.$utils.getDict([5, 338]).then((res) => {
        if (res) {
          this.packList = res[5]
          this.sterilizeMethods = res[338]
        }
      });
    },

    // 获取灭菌器选项
    getEquipments(str) {
      const query = {
        type: 2,
        search: str || "",
      };
      this.$request("get", getEquipment, query).then((res) => {
        if (res) {
          this.equipmentOptions = res;
        }
      });
    },

    // 获取人员信息
    getUserList(name) {
      let query = {
        name: name || "",
      };
      const url = userOptions.replace("{type}", 0);
      this.$request("get", url, query).then((res) => {
        this.registerUserList = res;
      });
    },

    // 获取人员信息
    getTagList(name = undefined) {
      this.$request("get", getTag, { name }).then((res) => {
        if(res){
          this.tagList = res;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-box{
  display: grid;
  grid-template-columns: repeat(auto-fill,460px);
  justify-content: space-between;
  gap:10px;
  margin-bottom: 20px;
}
.row1 {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 20px;
}
.row1Item {
  display: flex;
  align-items: center;
}
.lable-width{
  display: inline-block; /* 将 label 设置为行内块元素 */
  width: 114px;
}
.width-fixed{
  width: 340px !important;
}
.picker .el-range-input{
  font-size: 13px !important;
}
.picker .el-range-separator{
  line-height: 38px;
}
.picker {
  padding: 0 !important;
  padding-left: 10px !important;
}
</style>